export function makeQueryParams(object: any, astrict?: boolean) {
  let value = []
  for (let key in object) {
    if (object[key] != null || object[key] != undefined) value.push(astrict ? `&${key}=*${object[key]}*` : `&${key}=${object[key]}`);
  }
  let last: string = value.join('').split(',').toString();
  return last.substring(1);
}